import { Outlet } from "react-router-dom"
import DemyDashFinanNav from "../../components/dashNavbar/demyDashFinanNav"



export default function DemyFinanOut() {
  return (
    <div className="blogDashboard" style={{width:"100%"}}>
   <DemyDashFinanNav />
    <Outlet/>
        
    </div>
  )
}
